'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _fund_utility = require('../../../packages/common-utilities/src/fund_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YtdPercentageUS = function (_React$Component) {
  _inherits(YtdPercentageUS, _React$Component);

  function YtdPercentageUS(props) {
    _classCallCheck(this, YtdPercentageUS);

    var _this = _possibleConstructorReturn(this, (YtdPercentageUS.__proto__ || Object.getPrototypeOf(YtdPercentageUS)).call(this, props));

    _this.state = {
      dis: "none"
    };
    _this.tooltipId = "pdpSummaryYtdPopUp";
    _this.renderIcon = _this.renderIcon.bind(_this);
    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    return _this;
  }

  _createClass(YtdPercentageUS, [{
    key: 'renderIconDisclosure',
    value: function renderIconDisclosure() {
      if (!this.props.disclosure || (0, _ramda.isNil)(this.props.disclosure)) {
        return null;
      }

      return this.props.disclosure;
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(tooltipId, titleText) {
      var _this2 = this;

      if (!this.props.disclosure || (0, _ramda.isNil)(this.props.disclosure)) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + tooltipId, tabIndex: 0, className: 'icon-info print-hide',
          role: 'button',
          'aria-label': 'more information about ' + titleText,
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this2, event, _this2.handleDisclosureIconClick.bind(_this2, event, tooltipId));
          },
          onClick: function onClick(event) {
            return _this2.handleDisclosureIconClick(event, tooltipId);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, tooltipId) {
      var el = this.getIconEl(tooltipId);
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3
      };

      this.props.tooltip.openTooltip(elOffset, this.props.disclosure, null, true, event);
    }
  }, {
    key: 'getIconEl',
    value: function getIconEl(tooltipId) {
      return document.getElementById('disclosure-' + tooltipId);
    }
  }, {
    key: 'render',
    value: function render() {
      var formattedAsOfDate = _date_formatter2.default.getLocalFormattedDate(this.props.ytdDate, this.props.country);
      var title = !(0, _ramda.isNil)(this.props.title) ? this.props.title : _string_utility2.default.renderFormattedLabel("YTD", "label-for-ytd");
      var titleText = _string_utility2.default.getLocalizedString(this.props.intl, "YTD", "label-for-ytd");
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'tag font-black-variant ' },
            title,
            ' ',
            this.renderIcon(this.tooltipId, titleText)
          ),
          _react2.default.createElement('div', { className: '' + (this.props.breakpoint < 3 ? "camouflage" : ""), style: { display: this.state.dis } }),
          _react2.default.createElement(
            'div',
            { className: (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "disclaimer", "category") + ' font-slate-grey' },
            _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of", { role: this.props.role }),
            _react2.default.createElement(
              'span',
              { id: 'ytd-date' },
              formattedAsOfDate
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'display-inline-block margin-top-5 margin-right-10' },
          _react2.default.createElement(
            'span',
            { className: 'display-block disclaimer font-black-variant' },
            _string_utility2.default.renderFormattedLabel("at NAV", this.props.atNavLabelKey || "label-for-at-nav")
          ),
          _react2.default.createElement(
            'span',
            { className: 'display-block ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "tag", "sub-header-2") + ' font-black-variant', id: 'ytd-percentage' },
            _number_utility2.default.convertToAmountWithPreciseRounding(this.props.ytdPercentage, 2, "-", true, true, true)
          )
        ),
        !(0, _fund_utility.isUSEtfFund)(this.props.country, this.props.fundTypeCode) && !(0, _ramda.isNil)(this.props.salesChargeAdjustedYtdPercentage) && _react2.default.createElement(
          'div',
          { id: 'row-ytd-adjusted-percentage', className: 'display-inline-block margin-top-5 margin-right-10' },
          _react2.default.createElement(
            'span',
            { className: 'display-block disclaimer font-black-variant' },
            _string_utility2.default.renderFormattedLabel("with Sales Charge", this.props.atNavWithSalesChargeLabelKey || "label-for-at-nav-with-sales-charge")
          ),
          _react2.default.createElement(
            'span',
            { className: 'display-block ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "tag", "sub-header-2") + ' font-black-variant',
              id: 'sales-charge-adjusted-ytd-percentage' },
            _number_utility2.default.convertToAmountWithPreciseRounding(this.props.salesChargeAdjustedYtdPercentage, 2, "-", true, true, true)
          )
        ),
        !(0, _ramda.isNil)(this.props.disclosure) && _react2.default.createElement(
          'div',
          { 'data-testid': 'ytd-print-disclosure', className: 'text-justified font-light caption print-display print-page-break', style: { "display": "none" } },
          this.props.disclosure
        )
      );
    }
  }]);

  return YtdPercentageUS;
}(_react2.default.Component);

exports.default = YtdPercentageUS;